import { Component, OnInit } from '@angular/core';
import { FFUser } from '../common/models/users/ff-user.model';
import { AuthService } from '../common/services/auth.service';
import { DropdownService } from '../common/services/dropdown.service';
import { ButtonComponent, ButtonSizeEnumPipe, ButtonStyleEnumPipe, ButtonShapeEnumPipe, ButtonColorEnumPipe } from 'ui-library-shared';
import { ExternalLinkService } from '../common/services/external-link.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: true,
  imports: [ButtonComponent, ButtonSizeEnumPipe, ButtonStyleEnumPipe, ButtonShapeEnumPipe, ButtonColorEnumPipe]
})
export class HomeComponent implements OnInit {
  public userInfo: FFUser;
  public supportEmail: any;

  constructor(private authService: AuthService, private dropdownService: DropdownService, public externalLinkService: ExternalLinkService) { }

  ngOnInit(): void {
    this.authService.getUserInfo().then(res => {
      this.userInfo = res;
    });
    this.dropdownService.getGlobalDefaults().then(gd => {
      this.supportEmail = gd.find(x => x.globalDefaultId == "SupportEmail")?.textValue
    });
  }
}
